
const methods={
    base_url: 'http://web.fondcard.net/',
    //图片上传基本地址
    upload_img_base: `https://web.fondcard.net/open/store/api.php?`,
    //人脸图片路径
    type_face: '/face/',
    type_img:'/pic/img/',
    //人脸模板路径
    type_temp: "/temp/",
    //图片预览地址
    resident_pic_base: `https://web.fondcard.net/static`,
    type_head: '/pic/headee/',

}

// 导出请求方法
export default methods